import { render, staticRenderFns } from "./JobsReview.vue?vue&type=template&id=0e61a56d&scoped=true&"
import script from "./JobsReview.vue?vue&type=script&lang=js&"
export * from "./JobsReview.vue?vue&type=script&lang=js&"
import style0 from "./JobsReview.vue?vue&type=style&index=0&id=0e61a56d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61a56d",
  null
  
)

export default component.exports